import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData';

function RoleManPower() {
    return (
        <SettingsMetaData propertyName={"ManPowerRole"} viewPropertyName={"Role"} />
      );
}

export default RoleManPower
